import { render, staticRenderFns } from "./withdrawalManagement.vue?vue&type=template&id=152827df&scoped=true&"
import script from "./withdrawalManagement.vue?vue&type=script&lang=js&"
export * from "./withdrawalManagement.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalManagement.vue?vue&type=style&index=0&id=152827df&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152827df",
  null
  
)

export default component.exports